export function formatRupiah(amount, opts) {
    const n = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (Number.isNaN(n))
        return '-';
    const sign = n < 0 ? '-' : '';
    const abs = Math.abs(n);
    const s = abs.toFixed(2);
    const [int, frac] = s.split('.');
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withSymbol = opts?.withSymbol ?? true;
    return `${sign}${withSymbol ? 'Rp ' : ''}${grouped},${frac}`;
}
export function formatDate(iso) {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = d.getFullYear();
    return `${dd}/${mm}/${yy}`;
}
export function formatDateTime(iso) {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    const date = formatDate(d);
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${date} ${hh}:${mi}`;
}
